import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { programAccessQueryClient } from '@/components/admin/ProgramAccess/ProgramAccessTable/utils';
import { useModalManager } from '@/components/common/Modal';
import AddGlossaryTerm from './AddGlossaryTerm';

interface AddGlossaryTermButtonProps {
  buttonClassName: string;
  buttonText: string;
}

const AddGlossaryTermButton = ({ buttonClassName, buttonText }: AddGlossaryTermButtonProps) => {
  const modalManager = useModalManager();

  return (
    <QueryClientProvider client={programAccessQueryClient}>
      <button
        className={buttonClassName}
        type="button"
        onClick={modalManager.open}
      >
        {buttonText}
      </button>
      <AddGlossaryTerm
        handleClose={modalManager.close}
        isOpen={modalManager.isOpen}
      />
    </QueryClientProvider>
  );
};

export default AddGlossaryTermButton;
